import { AutoComplete, Button, Col, Input, PageHeader, Row } from 'antd';
import React, { ReactElement, useState } from 'react';

import useFetch from '../hooks/fetcher';
import { useHistory } from 'react-router-dom';
const API_SERVICE_BASE_URL = process.env.REACT_APP_API_SERVICE_BASE_URL || '';

type diseaseIdType = {
    id: string;
};

type countType = {
    count: string;
};

type diseaseType = {
    level4_description: string;
} & diseaseIdType;

type fetchResultType = {
    diseases: { data: diseaseType[] } & countType;
};

type optionType = {
    label: ReactElement;
    options: {
        value: string;
        label: ReactElement;
    }[];
};

const divider = '%%';

const renderItem = (
    title: string,
    table: string,
    column: string,
    diseaseId: string,
    key: number,
): { value: string; key: string; label: ReactElement } => ({
    value: title,
    key: table + divider + column + divider + title + divider + diseaseId + divider + key,
    label: (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
            }}
        >
            {title}
            <span></span>
        </div>
    ),
});

const updateResultCount = (data: fetchResultType): string => parseInt(data.diseases.count).toString();

const PageTarget: React.FC = () => {
    const { get } = useFetch(API_SERVICE_BASE_URL);
    const [options, setOptions] = useState<optionType[]>([]);
    const [resultCount, setresultCount] = useState<string>('');
    const history = useHistory();
    const gutterH = 16;
    const gutterV = 16;
    const colHelperProps = {
        xs: 0,
        sm: 0,
        md: 2,
        lg: 5,
        xl: 7,
    };
    const colContentProps = {
        xs: 24,
        sm: 24,
        md: 20,
        lg: 14,
        xl: 10,
    };

    const renderTitle = (
        title: string,
        count: string,
        resultShowed: number,
        column: string,
        sname: string,
    ): ReactElement => (
        <span>
            {title}
            {count === resultShowed.toString() ? (
                <b style={{ float: 'right' }}>{count} results</b>
            ) : (
                <Button
                    style={{ float: 'right' }}
                    type="link"
                    onClick={() => {
                        // if click on show all button, fetch all without limit
                        // eslint-disable-next-line @typescript-eslint/no-use-before-define
                        onSearch(sname, 0);
                    }}
                >
                    show all {count} results
                </Button>
            )}
        </span>
    );

    const updateOptions = (data: fetchResultType, keyword: string): optionType[] => {
        return [
            {
                label: renderTitle('Diseases', data.diseases.count, data.diseases.data.length, 'diseases', keyword),
                options: data.diseases.data.map((e, i) =>
                    renderItem(e.level4_description, 'tcm_info', 'diseases', e.id, i),
                ),
            },
        ];
    };

    // choose one of the results
    const onSelect = (e: string, opt: any): void => {
        const [table, column, keyword, diseaseId] = opt.key.split(divider);
        history.push(`/disease/detail/${diseaseId}`);
    };

    // onChange event
    const onSearch = (e: string, limit: number): Promise<void> =>
        get('/api/disease_idx.php', { name: e, limit: limit }).then((r: fetchResultType) => {
            setOptions(updateOptions(r, e));
            const c = updateResultCount(r);
        });

    // go to the search in all categories Page
    const onTriggerSelect = (keyword: string): void => {
        history.push(`/plant/list/all/${keyword}`);
    };

    return (
        <div>
            <PageHeader title="Disease search" style={{ marginBottom: '10vh' }} />
            <Row justify="space-between" gutter={[gutterH, gutterV]}>
                <Col {...colHelperProps}></Col>
                <Col {...colContentProps} style={{ display: 'flex' }}>
                    <AutoComplete
                        style={{ flex: 1 }}
                        options={options}
                        onSelect={onSelect}
                        onSearch={(e) => {
                            onSearch(e, 10);
                        }}
                    >
                        <Input.Search size="large" placeholder="Search disease" />
                    </AutoComplete>
                </Col>
                <Col {...colHelperProps}>{resultCount}</Col>
            </Row>
            <Row gutter={[gutterH, gutterV]}>
                <Col {...colHelperProps}></Col>
                <Col {...colContentProps}>
                    <div>
                        <br />
                        <strong>Examples:</strong>
                        <br />
                        Disease name:<strong> Tension-type headache</strong>
                    </div>
                </Col>
                <Col {...colHelperProps}></Col>
            </Row>
            <Row gutter={[gutterH, gutterV]}>
                <Col {...colHelperProps}></Col>
                <Col {...colContentProps}>
                    <div>
                        <strong>Info:</strong>
                        <br />
                        Here Search by ICD–10–CM description.
                        <br />
                        For the &quot;Chinese Disease search&quot; it is performed in the page of
                        <Button type="link" onClick={() => history.push('/recipe')}>
                            Recipe search
                        </Button>
                        .
                    </div>
                </Col>
                <Col {...colHelperProps}></Col>
            </Row>
        </div>
    );
};

export default PageTarget;
